<!--
Copyright 2019 ODK Central Developers
See the NOTICE file at the top-level directory of this distribution and at
https://github.com/getodk/central-frontend/blob/master/NOTICE.

This file is part of ODK Central. It is subject to the license terms in
the LICENSE file found in the top-level directory of this distribution and at
https://www.apache.org/licenses/LICENSE-2.0. No part of ODK Central,
including this file, may be copied, modified, propagated, or distributed
except according to the terms contained in the LICENSE file.
-->
<template>
  <page-section>
    <template #heading>
      <span>{{ $t('title') }}</span>
    </template>
    <template #body>
      <i18n tag="p" path="body[0].full">
        <template #accessTo>
          <router-link :to="projectPath('form-access')">{{ $t('body[0].accessTo') }}</router-link>
        </template>
      </i18n>
      <p>
        <i18n :tag="false" path="moreInfo.helpArticle.full">
          <template #helpArticle>
            <doc-link to="central-projects/">{{ $t('moreInfo.helpArticle.helpArticle') }}</doc-link>
          </template>
        </i18n>
        &nbsp;
        <i18n :tag="false" path="body[1].full">
          <template #forumThread>
            <a href="https://forum.getodk.org/t/-/19677" target="_blank">{{ $t('body[1].forumThread') }}</a>
          </template>
        </i18n>
      </p>
    </template>
  </page-section>
</template>

<script>
import DocLink from '../../doc-link.vue';
import PageSection from '../../page/section.vue';
import routes from '../../../mixins/routes';

export default {
  name: 'ProjectOverviewAbout',
  components: { DocLink, PageSection },
  mixins: [routes()]
};
</script>

<i18n lang="json5">
{
  "en": {
    // This is a title shown above a section of the page.
    "title": "About Projects",
    "body": [
      {
        "full": "Projects let you group related Forms and Users. Web Users can be given Roles that let them perform certain actions within this Project, including using a web browser to fill out Forms. App Users for this Project can only see Forms in this Project which they have {accessTo}.",
        "accessTo": "access to"
      },
      {
        "full": "If you have any feedback, please visit {forumThread}.",
        "forumThread": "this forum thread"
      }
    ]
  }
}
</i18n>

<!-- Autogenerated by destructure.js -->
<i18n>
{
  "cs": {
    "title": "O Projektech",
    "body": [
      {
        "full": "Projekty umožňují seskupovat související formuláře a uživatele. Webovým uživatelům mohou být přiděleny role, které jim umožní provádět určité akce v rámci tohoto projektu, včetně použití webového prohlížeče k vyplnění formulářů. Uživatelé aplikace pro tento projekt mohou vidět pouze formuláře v tomto projektu, ke kterému mají {accessTo}.",
        "accessTo": "přístup"
      },
      {
        "full": "Pokud chcete poskytnout zpětnou vazbu, navštivte prosím {forumThread}.",
        "forumThread": "toto diskusní fórum"
      }
    ]
  },
  "de": {
    "title": "Über Projekte",
    "body": [
      {
        "full": "Projekte lassen Sie zusammengehörige Formulare und Benutzer gruppieren. Web-Benutzer können Rollen erhalten, die es ihnen ermöglicht, bestimmte Aktionen innerhalb des Projekts auszuführen, einschließlich der Verwendung eines Webbrowsers zum Ausfüllen von Formularen. App-Benutzer des Projekts können Formulare nur in dem Projekt sehen, zu dem Sie {accessTo} haben.",
        "accessTo": "Zugriff auf"
      },
      {
        "full": "Wenn Sie Feedback haben, besuchen Sie bitte {forumThread}.",
        "forumThread": "diesen Forumsthread"
      }
    ]
  },
  "es": {
    "title": "Conocer proyectos",
    "body": [
      {
        "full": "Los proyectos permiten agrupar los formularios y usuarios relacionados. A los usuarios web se les puede asignar roles que les permitan realizar ciertas acciones dentro de este proyecto, incluyendo el uso de un navegador web para llenar formularios. Los usuarios móviles de este proyecto sólo podrán ver los formularios del proyecto al que tienen {accessTo}.",
        "accessTo": "acceso"
      },
      {
        "full": "Si tiene algún comentario, por favor visite {forumThread}.",
        "forumThread": "este hilo del foro"
      }
    ]
  },
  "fr": {
    "title": "A propos des projets",
    "body": [
      {
        "full": "Un projet vous permet de regrouper des formulaires et des usagers. Les utilisateurs web peuvent avoir des rôles qui leur permettent d'exécuter certaines actions dans ce projet, incluant remplir un formulaire depuis leur navigateur. Les utilisateurs mobiles pour ce projet ne peuvent que voir les formulaires auxquels ils ont {accessTo}.",
        "accessTo": "accès"
      },
      {
        "full": "Si vous avez des commentaires, veuillez participer à {forumThread}.",
        "forumThread": "ce fil de discussion du forum"
      }
    ]
  }
}
</i18n>
